const DotIcon = ({ className }: { className?: string }) => {
  return (
    <svg viewBox="0 0 8 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className} style={{ display: 'block' }}>
      <circle cx="4" cy="4" r="4" />
    </svg>
  );
};

export default DotIcon;

